<template>
  <div>
    <div>
      <div class="row" style="padding-bottom: 10px">
        <div class="col-md-2">
          <label for="starDate">{{$t('Tarixdən')}}</label>
          <el-date-picker size="small" id="starDate" format="dd.MM.yyyy" :picker-options="pickerOptions" type="date"
            :clearable="false" v-model="item.startDate">
          </el-date-picker>
        </div>
        <div class="col-md-2">
          <label for="endDate">{{$t('Tarixədək')}}</label>
          <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" :picker-options="pickerOptions" type="date"
            :clearable="false" v-model="item.endDate">
          </el-date-picker>
        </div>
        <div class="col-md-6">
        <label>  &nbsp;</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            &nbsp;
            <el-button   :title="$t('Axtarış')"  size="small" type="primary" icon="el-icon-search" @click="clickSearch"></el-button>
            &nbsp;
            <download-excel :fields="cells" :data="exportDataList" worksheet="My Worksheet" name="responses">
              <el-button size="small" @click="exportData" type="info"><i class="fa-solid fa-download"></i> {{$t('Export')}}
              </el-button>
            </download-excel>
          </div>
        </div>
      </div>
      </div>
    </div>
   
    <div class="row">
      <div class="col-12">
        <el-table ref="elTable" v-loading="loading" :data="displayData" style="width: 100%">
          <el-table-column :label="$t('Tarix')" sortable prop="reportDateStr" width="400">
          </el-table-column>
          <el-table-column :label="$t('Hadisə_sayı')" sortable prop="totalAccidents" width="400">
          </el-table-column>
          <el-table-column :label="$t('ZBT_sayı')" sortable prop="zbtCount">
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="filter.page"
            :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize" layout="sizes, prev, pager, next"
            :total="totalRecords">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateToString, AddMonths, AddDays } from "../../services/helper";
import { GetAccidentCountReport } from "src/services/report";

export default {
  components: {

  },
  data() {
    return {
      loading: false,
      data: [],
      exportDataList: [],
      totalRecords: 0,
      search: "",
      item: { startDate: null, endDate: null, searchType: 0, searchText: null, myData: false, uid: this.$store.state.user.id,dataExport: 0 },
      displayData: [],
      filter: {
        page: 1,
        pagesize: 50,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      cells: {
        'Tarix': 'reportDateStr',
        'Hadisə sayı': 'totalAccidents',
        'Zbt sayı': 'zbtCount',
      },
    };
  },
  methods: {

    handleCommand(item) {
      this.$refs["accident"].view(item);
    },
    handleStatusView(id) {
      this.$refs["status"].view(id);
    },
    clickSearch() {
      this.filter.page = 1
      this.getData();
    },
    exportData() {
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      this.item.dataExport = 1;
      GetAccidentCountReport(this.item).then((response) => {
        if (response.data) {
          this.exportDataList = response.data;
        }
      }).finally(() => {
        this.item.dataExport = 0;
      });
    },
    getData() {
      this.loading = true;
      if (this.item.searchText == "") {
        this.item.searchText = null;
      }

      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      this.item.pageNumber = this.filter.page;
      this.item.pageSize = this.filter.pagesize;
      this.item.dataExport = this.item.dataExport;

      GetAccidentCountReport(this.item).then((response) => {
        this.loading = false;
        if (response.data) {
          this.data = response.data;
          this.displayData = this.data;
          this.item.totalRecords =response.data[0].totalRecords;
        }
      });
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.filter.pagesize = val
      this.getData();
    },
    loadTime() {
      this.item.startDate = AddDays(new Date(), -7);
      this.item.endDate = new Date();
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
  },

};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
